import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconExternalLinkStyle0 = cosmosIconCss;

const CosmosIconExternalLink = /*@__PURE__*/ proxyCustomElement(class CosmosIconExternalLink extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '3f76ac2b00ea65467d273edcf1a7ee0299c78fe7', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '156a0415d3bceee24ddc09be7e8f8fd2f0c22327', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '7f884c84f8b8da70195ffe4cf555b2bdee8c5d16', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.967 4H17.6c.22 0 .4.18.4.4v5.625a.4.4 0 0 1-.683.284L15.18 8.175l-4.194 4.194a.5.5 0 0 1-.707 0l-.354-.353a.5.5 0 0 1 0-.707l4.194-4.194-2.435-2.432A.4.4 0 0 1 11.967 4ZM17 13h.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5V5a.5.5 0 0 1-.5.5h-3v11h11v-3a.5.5 0 0 1 .5-.5Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconExternalLinkStyle0; }
}, [1, "cosmos-icon-external-link", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-external-link"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-external-link":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconExternalLink);
            }
            break;
    } });
}

export { CosmosIconExternalLink as C, defineCustomElement as d };
